import { Icon } from '@/design-system/components/icons/Icon';
import { useNavigation } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { Pressable } from 'dripsy';

import * as React from 'react';
import { RootStackRoutes } from 'types';
import { DevToolsBottomSheet } from './screens/DevToolsBottomSheet';
import { DevToolsButton } from './screens/DevToolsButton';
import { DevToolsColours } from './screens/DevToolsColours';
import { DevToolsIcons } from './screens/DevToolsIcons';
import { DevToolsInput } from './screens/DevToolsInput';
import { DevToolsModal } from './screens/DevToolsModal';
import { DevToolsOthers } from './screens/DevToolsOtherComponents';
import { DevToolsGeneral } from './screens/DevToolsOthers';
import { DevToolsTable } from './screens/DevToolsTable';
import { DevToolsTypography } from './screens/DevToolsTypography';
import { DevToolsStackParamList, DevToolsStackRoutes } from './types';

const DevToolsStack = createNativeStackNavigator<DevToolsStackParamList>();

export const DevToolsNavigator = () => {
  const navigation = useNavigation();

  return (
    <DevToolsStack.Navigator
      initialRouteName={DevToolsStackRoutes.Main}
      screenOptions={{ headerShown: false, presentation: 'fullScreenModal' }}>
      <DevToolsStack.Screen name={DevToolsStackRoutes.Main} component={DevToolsGeneral} />
      <DevToolsStack.Screen name={DevToolsStackRoutes.Button} component={DevToolsButton} />
      <DevToolsStack.Screen name={DevToolsStackRoutes.Colours} component={DevToolsColours} />
      <DevToolsStack.Screen name={DevToolsStackRoutes.Icons} component={DevToolsIcons} />
      <DevToolsStack.Screen name={DevToolsStackRoutes.Input} component={DevToolsInput} />
      <DevToolsStack.Screen name={DevToolsStackRoutes.Typography} component={DevToolsTypography} />
      <DevToolsStack.Screen name={DevToolsStackRoutes.Table} component={DevToolsTable} />
      <DevToolsStack.Screen name={DevToolsStackRoutes.Others} component={DevToolsOthers} />
      <DevToolsStack.Screen
        name={DevToolsStackRoutes.BottomSheet}
        component={DevToolsBottomSheet}
        options={{ presentation: 'transparentModal' }}
      />
      <DevToolsStack.Screen name={DevToolsStackRoutes.Modal} component={DevToolsModal} options={{ presentation: 'transparentModal' }} />
    </DevToolsStack.Navigator>
  );
};
